function SearchParameters(options) {

    this.defaultParams = {
        q: null,
        filters: [],
        paths: [],
        page: 0,
        size: 10,
        from: 0,
        order: {},
        geo: {
            lat: null,
            lon: null,
        },
        certification1: '',
        certification2: '',
        certification3: '',
        exclude: null,
        fb: 'must',
        pb: 'must',
    };

    this.params = this.defaultParams;

    this.parseOptions = function (options) {
        Object.keys(options).forEach((k) => {
            if (this.params[k]) {
                this.params[k] = ['filters', 'paths'].indexOf(k) >= 0 ? arrayify(options[k]) : options[k];
            }
        });
    };

    if (options) {
        this.parseOptions(options);
    }

    this.setConditions = function (useLocation) {

        if (typeof useLocation === 'undefined') {
            useLocation = true;
        }
        this.params.filters = this.params.filters.filter(x => x);
        this.params.paths = this.params.paths.filter(x => x);

        this.params.fb = this.params.filters.length >= 2 ? 'should' : 'must';
        this.params.pb = this.params.paths.length >= 2 ? 'should' : 'must';

        if (locationService.hasCoordinates() && useLocation === true) {
            this.params.geo.lat = locationService.getLocation().lat;
            this.params.geo.lon = locationService.getLocation().lng;
        }
    };

    this.duplicate = function () {
        return new SearchParameters(this.params);
    };


    this.parseParams = function () {

        this.params.q = $.urlParam('q') || '';
        this.params.filters = arrayify($.urlParam('filters'));
        this.params.order = $.urlParam('order');

        this.params.paths = arrayify($.urlParam('paths'));
        this.params.page = $.urlParam('page') || 1;
        this.params.certification1 = $.urlParam('certification1');
        this.params.certification2 = $.urlParam('certification2');
        this.params.certification3 = $.urlParam('certification3');

        this.params.from = (parseInt(this.params.page, 10) - 1) * 10;
        this.params.from = this.params.from < 0 ? 0 : this.params.from;
    };

    this.doSearch = function () {

        let searchRequestListener = new Event('searchRequestListener');
        document.dispatchEvent(searchRequestListener);

        this.setConditions();

        return $.get('/@mb', this.params);
    };
}

const searchParams = (function () {
    'use strict';

    const main = {

        q: null,
        filters: [],
        paths: [],
        page: 0,
        size: 10,
        from: 0,
        order: {},
        geo: {
            lat: null,
            lon: null,
        },
        certification1: null,
        certification2: null,
        certification3: null,
        exclude: null,
        fb: '',
        ab: '',
        pb: '',
        cb: '',

        setQuery: query => main.q = query,

        setFilter: function (filter) {
            Array.isArray(filter) ? main.filters = filter :
            main.filters.indexOf(filter) < 0 ? main.filters.push(filter) : '';

        },

        removeFilter: function (filter) {
            let i = main.filters.indexOf(filter);
            i >= 0 ? main.filters.splice(i, 1) : '';
        },

        setPath: path => main.paths = arrayify(path),

        getPath: () => main.paths,

        setPage: function (page) {
            main.page = page;
        },

        setSize: function (size) {
            main.size = size;
        },

        setGeo: function (geoObj) {
            main.geo = {
                lat: geoObj.lat,
                lon: geoObj.lon
            };
        },

        setOrder: order => main.order = order,

        setConditions: function (useLocation) {

            if (typeof useLocation === 'undefined') {
                useLocation = true;
            }
            main.filters = main.filters.filter(x => x);
            main.paths = main.paths.filter(x => x);

            main.fb = main.filters.length >= 2 ? 'should' : 'must';
            main.pb = main.paths.length >= 2 ? 'should' : 'must';

            if (locationService.hasCoordinates() && useLocation === true) {
                main.setGeo({lat: locationService.getLocation().lat, lon: locationService.getLocation().lng});
            }

        },

        setCertification1: function (cert) {
            main.certification1 = cert;
        },

        setCertification2: function (cert) {
            main.certification2 = cert;
        },

        setCertification3: function (cert) {
            main.certification3 = cert;
        },

        setExclude: function (exclude) {
            main.exclude = exclude;
        },

        getPage: function () {
            return main.page;
        },

        getFilterParams: function () {
            return {
                q: main.q,
                'filters[]': main.filters,
                'paths[]': main.paths,
                size: main.size,
                from: main.from,
                order: main.order,
                fb: main.fb,
                pb: main.pb,
                ab: main.ab,
                cb: main.cb,
                exclude: main.exclude,
                certification1: main.certification1,
                certification2: main.certification2,
                certification3: main.certification3,
                geo: main.geo,
                customLocation: locationService.getLocation()
            };
        },

        getFilterUrlParams: function () {
            let fp = {
                q: $.urlParam('q') || '',
                'filters[]': $.urlParam('filters') || '',
                'paths[]': arrayify($.urlParam('paths[]')),
                page: $.urlParam('page') || 1,
                certification1: $.urlParam('certification1') || null,
                certification2: $.urlParam('certification2') || null,
                certification3: $.urlParam('certification3') || null
            };


            if (typeof window.__get__ !== 'undefined') {
                fp = Object.assign(fp, window.__get__);
            }

            return fp;
        },

        setFromQuery: function () {
            ['q', 'filters', 'paths[]', 'page', 'certification1', 'certification2', 'certification3'].map(function (q) {
                let param = $.urlParam(q);
                console.log(q, param);
                if (param) {
                    main[q === 'filters' ? 'filters[]' : q] = param;
                }
            });

            return main;
        },

        doSearch: function () {
            //We need to set the conditions before make the ajax call.
            //Set the page:
            main.from = (parseInt(main.page, 10) - 1) * 10;
            main.from = main.from < 0 ? 0 : main.from;

            var searchRequestListener = new CustomEvent('searchRequestListener');

            // if (typeof Event === 'function') {
            //     searchRequestListener = new Event('searchRequestListener');
            // } else {
            //     searchRequestListener = jQuery.Event('searchRequestListener');


            // searchRequestListener = document.createEvent('Event');
            // event.initEvent('searchRequestListener', true, true);
            // }


            //Dispatch the event that fills up the main object with the parameters.
            document.dispatchEvent(searchRequestListener);

            main.setConditions();

            return $.get('/@mb', main.getFilterParams()).always(function () {
                //Reset the object to the next call :)
                main.setToDefault();
            });
        },

        doTop5List: function (conditionParams, useLocation) {

            if (typeof useLocation === 'undefined') {
                useLocation = true;
            }


            main.setConditions(useLocation);

            if (conditionParams) {
                main.fb = conditionParams.fb || 'must';
                main.pb = conditionParams.pb || 'must';
            }

            main.order = {
                rating: 'desc'
            };

            return $.get('/@mb', main.getFilterParams(), function (response) {
                return response;
            }).always(function () {
                //Reset the object to the next call :)
                main.setToDefault();
            });
        },

        setToDefault: function () {
            main.q = null;
            main.filters = [];
            main.paths = [];

            main.page = 0;

            main.size = 10;
            main.from = 0;
            main.order = {};

            main.geo = {
                lat: null,
                lon: null
            };

            main.exclude = null;

            main.certification1 = null;
            main.certification2 = null;
            main.certification3 = null;

            main.fb = '';
            main.ab = '';
            main.pb = '';
            main.cb = '';
        }
    };

    return main;
}());